module.exports = __webpack_public_path__ + "static/media/animals.d0113903.png";